<template>

  <div class="main-container">

    <section  class="container mt-0 pt-0">

          <div class="row m-0 pb-3 p-0 bg-white">
            
            <div class="col-12 col-md-6 offset-md-3 mt-5">

              <div class="row">

                <div class="pl-0 col-12 text-center">
                  <b-img v-if="photo" rounded="circle" :src="photo" blank-color="#ccc" alt="placeholder" height="120" width="120" class="light-grey-border"></b-img>
                  <b-img v-else rounded="circle" blank blank-color="#ccc" alt="placeholder" height="120" width="120" class="light-grey-border"></b-img>
                  <p class="font-weight-normal mb-1 mt-2 mb-0 pb-0 dark-text h3 mt-3">We’re Good!</p>
                </div>
              </div>

            </div>

            <div id="chipin-form" class="col-12 col-md-6 offset-md-3 mt-2">

              <p class="font-weight-light mb-1 text-center">Payment Successful. <br> Thanks for your support.</p>
    
              <p class="text-center mt-5 pt-5">
                <b-button class="mb-4 px-5 py-2 rounded-btn" size="md" variant="info" @click="confirm()">
                  &nbsp;&nbsp;&nbsp;&nbsp;Enjoy!&nbsp;&nbsp;&nbsp;&nbsp;
                </b-button>
                <br>
              </p>

            </div>


        </div>

      </section>

  </div>
  
</template>

<script>

  export default {
    name: 'ChipInSuccess',
    data() {
      return {
        photo: localStorage.getItem('userimage')
      }
    },
    methods: {
      confirm() {

        let locked = false;

        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.SuccessHandler) {
            window.webkit.messageHandlers.SuccessHandler.postMessage({
                "locked": locked
            });
        }
        
      }
    },
    mounted() {

      if (!this.$route.query.payment_to) {
        this.$router.push('/error')
      }


    }
  }

</script>

<style scoped>

  .light-grey-border {
    border: 2px solid #9B9B9B
  }

  .red-text {
    color: #FF0000;
  }
  
  .dark-text {
    color: #595959;
  }

  .super-small {
    font-size: 0.7em;
    color: #595959;
  }

  .rounded-btn {
    border-radius: 10px;
  }

</style>